import styled from "@emotion/styled";
import { FC, useMemo } from "react";
import {
  MDSButton,
  MDSButtonVariant,
  MDSButtonIcon,
  MDSButtonSlotName,
  MDSButtonLoadingIndicator,
} from "@/mds";
import { MdsIconKind } from "@/design-system/components/icon";

interface HeadsUpFindMoreButtonProps {
  onClick: () => void;
  isLoading: boolean;
  isDisabled: boolean;
}

export const HeadsUpFindMoreButton: FC<HeadsUpFindMoreButtonProps> = ({
  onClick,
  isLoading,
  isDisabled,
}) => {
  const label = useMemo(() => {
    if (isLoading) {
      return "Finding more";
    }

    return "Find more";
  }, [isLoading]);

  return (
    <FindMoreButton
      variant={MDSButtonVariant.Transparent}
      onClick={onClick}
      isDisabled={isDisabled}
      isLoading={isLoading}
      loadingIndicator={MDSButtonLoadingIndicator.Icon}
    >
      <MDSButtonIcon slot={MDSButtonSlotName.LeftIcon} kind={MdsIconKind.Telescope} />
      {label}
    </FindMoreButton>
  );
};

const FindMoreButton = styled(MDSButton)`
  box-shadow: none;
  border: 1px solid ${({ theme }) => theme.colors.border.default};
  background-color: ${({ theme }) => theme.colors.background.button.transparent.default};
  color: ${({ theme }) => theme.colors.text.primary};
  height: 44px;

  &[data-hovered]:not([data-disabled]) {
    background-color: ${({ theme }) => theme.colors.background.button.transparent.hover};
  }

  &[data-pressed]:not([data-disabled]) {
    transform: translateY(1px);
  }

  &:disabled,
  &[disabled] {
    cursor: not-allowed;
    pointer-events: none;
  }
`;
